import {checkAndSearch} from '../index.js';
import {setErrorState} from '../index.js';
import {unsetErrorState} from '../index.js';
const $search = $('.search.search--result');

if ($search.length) {
	const config = require('./config.yaml');
	const $searchInput = $search.find('.js-search-input');
	const $searchMessage = $search.find('.js-search-message');
	const searchHideMessageType = config.searchMessageBottom ? 'transition.slideUpOut' : 'transition.slideDownOut';
	const searchShowMessageType = config.searchMessageBottom ? 'transition.slideDownIn' : 'transition.slideUpIn';

	$searchInput
		.on('focus', function () {
			var $this = $(this);
			$searchMessage.velocity(searchHideMessageType, 200);
			unsetErrorState($search);
		});

	$search.on('submit', function (event) {
		checkAndSearch(event, searchShowMessageType, $(this));
	});
}



// WEBPACK FOOTER //
// ./temp/components/search-form/result/index.js